<template>
  <div class="bak">
    <b-form-group label-for="input-statement" label="지시문(직독직해)">
      <b-form-input
        :class="statement_valid_cls"
        id="input-statement"
        v-model="statement"
      ></b-form-input>
    </b-form-group>
    <b-form-group label-for="input-statement4" label="지시문(구조분석)">
      <b-form-input
        :class="statement4_valid_cls"
        id="input-statement4"
        v-model="statement4"
      ></b-form-input>
    </b-form-group>

    <b-form-group label-for="input-statement2" label="지시문(스크램블)">
      <b-form-input
        :class="statement2_valid_cls"
        id="input-statement2"
        v-model="statement2"
      ></b-form-input>
    </b-form-group>

    <b-form-group label-for="input-statement3" label="지시문(영작)">
      <b-form-input
        :class="statement3_valid_cls"
        id="input-statement3"
        v-model="statement3"
      ></b-form-input>
    </b-form-group>

    <div :class="title_valid_cls">
      <div>문제 *</div>
      <SenEditor
        ref="editor1"
        v-on:processing="appendAnswer"
        func="updateQTitle"
        :content="title"
      />
    </div>

    <div :class="senintent_valid_cls">
      <b-card no-body>
        <b-tabs card>
          <b-tab @click="chgFlag('1')" title="분석" v-bind:active="flag == '1'">
            <b-card-text>
              <SenAnswer
                :item="item"
                :key="item.id"
                v-for="item in ays_answers"
              />
              <div class="notfound_items" v-if="ays_answers.length == 0">
                문제를 통해서 추가가능
              </div>

              <SenAnswerAppendButton v-if="1 == 2" />
            </b-card-text>
          </b-tab>
          <b-tab @click="chgFlag('2')" title="해석" v-bind:active="flag == '2'">
            <b-card-text>
              <SenAnswer
                :item="item"
                :key="item.id"
                v-for="item in comt_answers"
              />
              <div class="notfound_items" v-if="comt_answers.length == 0">
                문제를 통해서 추가가능
              </div>
              <SenAnswerAppendButton v-if="1 == 2" />
            </b-card-text>
          </b-tab>
          <b-tab
            @click="chgFlag('3')"
            title="스크램블"
            v-bind:active="flag == '3'"
          >
            <b-card-text>
              <SenAnswer
                :item="item"
                :key="item.id"
                v-for="item in shuffle_answers"
              />
              <div class="notfound_items" v-if="shuffle_answers.length == 0">
                문제를 통해서 추가가능
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>

    <div>해설</div>
    <NormalEditor
      key="ned_2"
      ref="editor3"
      :content="qcomment"
      func="updateQComment"
    />

    <b-row class="imagepanel">
      <b-col>
        <FileUpload utype="image" fileobj="image" v-if="image == ''" />
        <div v-else>
          <div>이미지</div>
          <div class="file-result">
            <img :src="image" class="preview" />
            <b-button size="sm" variant="danger" @click="removeimg()"
              >삭제</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <VideoForm :video="video" :key="video.id" v-for="video in videos" />
    <b-row>
      <b-col>
        <b-form-group>
          <b-button block size="sm" @click="appendVideo">
            동영상추가(+)
          </b-button>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <FileUpload utype="sound" fileobj="sound" v-if="sound == ''" />

        <div v-else>
          <div>사운드</div>
          <div class="file-result">
            {{ sound }}
            <b-button size="sm" variant="danger" @click="removesnd()"
              >삭제</b-button
            >
          </div>
        </div>
      </b-col>
    </b-row>

    <LevelForm />

    <b-row style="margin-bottom: 15px">
      <b-col sm="4" lg="4" :class="senlevel_valid_cls" v-show="1 == 2">
        <b-form-group
          label="레벨:"
          label-cols-sm="3"
          label-cols-lg="2"
          label-for="input-wordlevel"
        >
          <b-form-select
            v-model="lvl_senselected"
            :options="senlvl_options"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="5" lg="5" v-show="1 == 2">
        <b-form-group
          label="어휘:"
          label-cols-sm="3"
          label-cols-lg="2"
          label-for="input-wordlevel"
        >
          <b-form-select
            v-model="word_level"
            :options="word_level_options"
          ></b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-input
          placeholder="기출정보"
          id="input-previnfo"
          v-model="prevtest_info"
        />
      </b-col>
    </b-row>
    <b-button @click="binddic()" v-show="1 == 2">레벨체크</b-button>

    <div style="text-align: left; margin-bottom: 10px" v-if="meta_id != ''">
      <b-button
        @click="openDup()"
        size="sm"
        style="width: 100%"
        variant="danger"
        >중복문항 체크</b-button
      >
    </div>

    <b-row>
      <b-col class="button_wrapper">
        <b-button @click="save" variant="primary" class="float-right">{{
          saveorupdate_title
        }}</b-button>
        <b-button @click="cancel" variant="danger" class="float-right"
          >취소</b-button
        >
      </b-col>
    </b-row>
    <SenReadingDup main_metaid="idf" />
  </div>
</template>

<script>
import SenEditor from "@/components/SenEditor";
import Editor from "@/components/Editor";
import NormalEditor from "@/components/NormalEditor";
import SenCommandForm from "@/components/question/SenCommandForm";
import SenAnswer from "@/components/question/SenAnswer";
import SenAnswerAppendButton from "@/components/question/SenAnswerAppendButton";

import FileUpload from "@/components/FileUpload";
import VideoForm from "@/components/question/VideoForm";
import SenLevelForm from "@/components/question/SenLevelForm";
import LevelForm from "@/components/question/LevelForm";

import SenReadingDup from "@/components/question/SenReadingDup";

import { mapState, mapActions } from "vuex";

import axios from "axios";

const senStore = "senStore";
const SERVER_URL = `${process.env.VUE_APP_SERVER_URL}`;
export default {
  components: {
    SenEditor,
    NormalEditor,
    SenAnswer,
    SenAnswerAppendButton,
    FileUpload,
    VideoForm,
    LevelForm,
    SenReadingDup,
  },
  mounted() {
    // alert("mounted");
    if (this.$store.state.questionmeta.id == "") {
      this.$refs.editor1.reset();

      this.$refs.editor3.reset();
    }
  },
  watch: {
    metaid(to, from) {
      if (to == "") {
        this.$refs.editor1.reset();
        this.$refs.editor3.reset();
      }
      console.log(to);
    },
  },

  computed: {
    ...mapState(senStore, ["flag", "senlvl_options", "senvalid"]),

    meta_id() {
      return this.$store.state.questionmeta.id;
    },

    lvl_senselected: {
      get() {
        return this.$store.state.questionform.senlevel;
      },
      set(val) {
        this.$store.commit("updateSenLevel", val);
      },
    },

    word_level_options() {
      return this.$store.state.word_level_options;
    },

    word_level: {
      get() {
        return this.$store.state.questionform.word_level;
      },
      set(val) {
        this.$store.commit("updateWordLevel", val);
      },
    },

    senlevel_valid_cls() {
      return this.$store.state.valid.senlevel;
    },

    statement_valid_cls() {
      return this.$store.state.valid.statement;
    },
    statement2_valid_cls() {
      return this.$store.state.valid.statement2;
    },
    statement3_valid_cls() {
      return this.$store.state.valid.statement3;
    },
    statement4_valid_cls() {
      return this.$store.state.valid.statement4;
    },

    senintent_valid_cls() {
      return this.senvalid.intent;
    },

    metaid() {
      return this.$store.state.questionmeta.id;
    },

    qid() {
      return this.$store.state.questionform.id;
    },

    title() {
      return this.$store.state.questionform.title_imsi;
    },
    qcomment() {
      return this.$store.state.questionmeta.qcomment_imsi;
    },
    videos() {
      return this.$store.state.questionform.videos;
    },
    image() {
      return this.$store.state.questionform.image;
    },
    sound() {
      return this.$store.state.questionform.sound;
    },

    title_valid_cls() {
      return this.$store.state.valid.title;
    },
    saveorupdate_title() {
      return this.qid == "" ? "저장" : "수정";
      // return "저장";
    },
    prevtest_info: {
      get() {
        return this.$store.state.questionform.prevtest_info;
      },
      set(val) {
        this.$store.commit("updatePrevtestInfo", val);
      },
    },

    statement: {
      get() {
        return this.$store.state.questionmeta.statement;
      },
      set(val) {
        this.$store.commit("updateStatement", val);
      },
    },
    statement2: {
      get() {
        return this.$store.state.questionmeta.statement2;
      },
      set(val) {
        this.$store.commit("updateStatement2", val);
      },
    },
    statement3: {
      get() {
        return this.$store.state.questionmeta.statement3;
      },
      set(val) {
        this.$store.commit("updateStatement3", val);
      },
    },
    statement4: {
      get() {
        return this.$store.state.questionmeta.statement4;
      },
      set(val) {
        this.$store.commit("updateStatement4", val);
      },
    },

    ...mapState(senStore, ["ays_answers", "comt_answers", "shuffle_answers"]),
  },
  methods: {
    ...mapActions(senStore, [
      "AC_AYS_ANSWER_APPEND",
      "AC_COMT_ANSWER_APPEND",
      "AC_SHUFFLE_ANSWER_APPEND",
    ]),
    ...mapActions(senStore, ["AC_FLAG_UPDATE", "AC_SAVE_SEN"]),
    appendAnswer(txt, strt) {
      this.$store.commit("updateDebug", strt);

      if (this.flag == "1") {
        let obj = { id: "0", text: txt, strt: strt, intent: "" };
        obj.id = this.ays_answers.length + 1;
        this.AC_AYS_ANSWER_APPEND(obj);
        if (this.ays_answers.length > 0) {
          obj.intent = this.ays_answers[0].intent;
        }
      } else if (this.flag == "2") {
        let obj = { id: "0", text: txt, strt: "", intent: "" };
        obj.id = this.comt_answers.length + 1;
        if (this.comt_answers.length > 0) {
          obj.intent = this.comt_answers[0].intent;
        }

        this.AC_COMT_ANSWER_APPEND(obj);
      } else if (this.flag == "3") {
        let obj = { id: "0", text: txt, strt: "", intent: "" };
        obj.id = this.shuffle_answers.length + 1;
        if (this.shuffle_answers.length > 0) {
          obj.intent = this.shuffle_answers[0].intent;
        }
        this.AC_SHUFFLE_ANSWER_APPEND(obj);
      }
    },
    chgFlag(flag) {
      this.AC_FLAG_UPDATE(flag);
    },

    appendVideo() {
      this.$store.dispatch("appendVideo");
    },

    async save() {
      let _k = await this.AC_SAVE_SEN();

      if (!_k) {
        alert("폼을 확인해주세요");
        return false;
      }
      // this.$store.commit("updateDebug", "리턴이후 실행");
      this.$nextTick(() => {
        this.$refs.editor1.reset();
        this.$refs.editor3.reset();
      });
    },
    cancel() {
      this.$refs.editor1.reset();
      this.$refs.editor3.reset();
      this.$store.commit("resetQuestionForm");
      this.$store.commit("resetQuestionMeta");
    },
    removeimg() {
      this.$store.commit("updateImage", "");
    },
    removesnd() {
      this.$store.commit("updateSound", "");
    },
    async binddic() {
      let title = this.$store.state.questionform.title;
      title = title.replace(/<[^>]*>?/gm, "");
      let titles = title.split(" ");

      let flevel = 3;
      for (let i = 0; i < titles.length; i++) {
        if (titles[i] != "") {
          console.log(titles[i]);
          let url = `${SERVER_URL}/query?q=${titles[i]}`;
          await axios.get(url).then((resp) => {
            let data = resp.data;
            let klvl = 0;
            console.log(data.status);
            if (data.status.indexOf("ico_star1") >= 0) {
              klvl = 1;
            } else if (data.status.indexOf("ico_star2") >= 0) {
              klvl = 2;
            } else if (data.status.indexOf("ico_star3") >= 0) {
              klvl = 3;
            } else {
              console.log("catch here");
              klvl = 0;
            }
            if (flevel > klvl) {
              flevel = klvl;
            }
          });
        }
      }

      this.word_level = flevel + "";

      if (titles.length < 14) {
        this.lvl_senselected = "1";
      } else if (titles.length >= 14 && titles.length < 22) {
        this.lvl_senselected = "2";
      } else if (titles.length >= 22 && titles.length < 26) {
        this.lvl_senselected = "3";
      } else if (titles.length >= 26) {
        this.lvl_senselected = "4";
      }
      alert("레벨체크 완료");
    },
    openDup() {
      // this.formChapter = {};
      this.$nextTick(() => {
        this.$bvModal.show("myiddup");
      });
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.invalid {
  border: 2px solid red;
}

.button_wrapper {
  button {
    margin-right: 5px;
    margin-bottom: 20px;
  }
}

.imagepanel {
  margin-bottom: 20px;
  margin-top: 20px;

  .file-result {
    display: flex;
    align-items: flex-end;

    .preview {
      max-height: 100px;
    }
  }
}

.bak {
  background-color: white;
  padding: 10px 15px 10px 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 10px;
}
.notfound_items {
  text-align: center;
  font-weight: 700;
  color: $gray400;
}
</style>
